import React, { lazy, Suspense } from 'react';
import { Loader } from './Loader';

const WellsFargoNonConfirmingJumbo = lazy(() => import('../pages/wells-fargo-non-confirming-jumbo-page/index'));

const WhlPageWrapper = ({
    pageDetails
}) => {

    const { pageName } = pageDetails

    return <>
        {
            pageName === 'Wells Fargo Non-Conforming Jumbo' && <>
                <Suspense fallback={<Loader />}>
                    <WellsFargoNonConfirmingJumbo pageDetails={pageDetails} />
                </Suspense>
            </>
        }
    </>

}

export default WhlPageWrapper;
